export default [
  {
    path: "/login",
    name: "foravila-login",
    component: () => import("@/views/security/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      mustBeLoggedOut: true,
    },
  },
  {
    path: "/logout",
    name: "foravila-logout",
    component: () => import("@/views/security/Logout.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/forgot-password",
    name: "foravila-forgot-password",
    component: () => import("@/views/security/ForgotPassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      mustBeLoggedOut: true,
    },
  },
  {
    path: "/check-email",
    name: "foravila-check-email",
    component: () => import("@/views/security/CheckEmail.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      mustBeLoggedOut: true,
    },
  },
  {
    path: "/reset-password/:token?",
    name: "foravila-reset-password",
    component: () => import("@/views/security/ResetPassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      mustBeLoggedOut: true,
    },
  },
  {
    path: "/set-password",
    name: "foravila-set-password",
    component: () => import("@/views/security/SetPassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/register/:token?",
    name: "foravila-register",
    component: () => import("@/views/security/Register.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      mustBeLoggedOut: true,
    },
  },
  {
    path: "/not-authorized",
    name: "not-authorized",
    component: () => import("@/views/security/NotAuthorized.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/not-found",
    name: "not-found",
    component: () => import("@/views/security/NotFound.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
];
